import { normalize } from 'normalizr';
import type { Client } from '@core/api/utils';
import { pipeData } from '@core/api/utils';
import type { ApiMetadata } from './apiTypes';
import { toInstructor } from './mappers';
import { toClassTypeSchema } from './models/ClassType';
import { toContentFocusLabelSchema } from './models/ContentFocusLabel';
import { toDeviceTypeDisplayNamesSchema } from './models/DeviceTypeDisplayName';
import { toEquipmentSchema } from './models/Equipment';
import { toFitnessDisciplineSchema } from './models/FitnessDiscipline';
import { toInstructorSchema } from './models/Instructor';
import { toLocaleSchema } from './models/Locale';

export const fetchMetadata = (api: Client) =>
  api.get('/api/ride/metadata_mappings').then(pipeData(toMetadata));

const metadata = {
  classTypes: [toClassTypeSchema()],
  deviceTypeDisplayNames: [toDeviceTypeDisplayNamesSchema({ idAttribute: 'deviceType' })],
  equipment: [toEquipmentSchema()],
  fitnessDisciplines: [toFitnessDisciplineSchema()],
  instructors: [toInstructorSchema({ processStrategy: toInstructor })],
  locales: [toLocaleSchema()],
  contentFocusLabels: [toContentFocusLabelSchema()],
};

export const toMetadata = (apiMetadata: ApiMetadata) => normalize(apiMetadata, metadata);

// Re-export types for backwards compatibility
export type {
  ApiMetadata,
  ApiInstructor,
  ApiContentFocusLabel,
  ApiFitnessDiscipline,
  ApiClassType,
  ApiEquipment,
  ApiDeviceTypeDisplayName,
  ApiLocale,
} from './apiTypes';
